import type { ColumnDef } from "@tanstack/react-table";

import { credentialStatusFormatter } from "./formatters";
import type { ICredentialsData } from "./types";

import { translate } from "utils/translations/translate";

const getColumns = (): ColumnDef<ICredentialsData>[] => {
  return [
    {
      accessorKey: "name",
      header: translate.t(`organization.tabs.credentials.table.columns.name`),
      id: "name",
      minSize: 300,
    },
    {
      accessorKey: "owner",
      header: translate.t(`organization.tabs.credentials.table.columns.owner`),
      id: "owner",
      minSize: 300,
    },
    {
      accessorKey: "usedBy",
      cell: credentialStatusFormatter,
      enableSorting: false,
      header: translate.t(`organization.tabs.credentials.table.columns.used`),
      id: "usedBy",
      minSize: 300,
    },
    {
      accessorKey: "formattedType",
      header: translate.t(`organization.tabs.credentials.table.columns.type`),
      id: "formattedType",
    },
  ];
};

export { getColumns };
